'use strict';

/**
 * Recursive function used to build a mapping of category keys to categories
 *  (E.G.
 *      categories = [{
 *          key: 'F',
 *          children: [{
 *              key: 'F_SEA',
 *              children: [{
 *                  key: 'F_SEA_COU'
 *              }, {
 *                  key: 'F_SEA_ARM'
 *              }]
 *          }]
 *      },{
 *          key: 'A',
 *          children: [{
 *              key: 'A_PHO',
 *              children: [{
 *                  key: 'A_PHO_PIC'
 *              }]
 *          }]
 *      }]
 *  => OUTPUT = {
 *      F: {key: 'F'...}
 *      F_SEA: {key: 'F_SEA'...}
 *      F_SEA_COU: {key: 'F_SEA_COU'...},
 *      F_SEA_ARM: {key: 'F_SEA_ARM'...},
 *      A: {key: 'A'...}
 *      A_PHO: {key: 'A_PHO'}
 *      A_PHO_PIC: {key: 'A_PHO_PIC'}
 *  }
 *
 * @param {array} categories - an array of categories each with a key and children
 * @param {Object} [map] - Map that is ultimately output with each key=category.key and
 *  value=category
 * @returns {Object}
 */
function buildCategoriesMap(categories, map = {}) {
    return categories.reduce((_map, category) => {
        _map[category.key] = Object.assign({}, category);
        delete _map[category.key].children;

        if (category.children && category.children.length) {
            buildCategoriesMap(category.children, _map);
        }

        return _map;
    }, map);
}

const CategoriesStore = {
    storeName: 'CategoriesStore',

    initialState: {
        categories: [],
        categoriesMap: {}
    },

    reducers: {
        SET_CATEGORIES(state, categories) {
            return Object.assign({}, state, {
                categories,
                categoriesMap: buildCategoriesMap(categories)
            });
        }
    },

    getters: {
        getCategories(state) {
            return state.categories;
        },

        getCategoriesMap(state) {
            return state.categoriesMap;
        },

        getCategoryByKey(state, categoryKey) {
            return state.categoriesMap[categoryKey];
        }
    }
};

module.exports = CategoriesStore;



// WEBPACK FOOTER //
// ./assets/js/global/stores/CategoriesStore.es.js